export const getInventeringDateText = (start_ar?: string, slut_ar?: string): string => {
  if (start_ar && slut_ar) {
    return `${start_ar.slice(0, 4)}–${slut_ar.slice(0, 4)}`;
  } else if (start_ar) {
    return start_ar.slice(0, 4);
  } else {
    return '';
  }
};
